import React from 'react';
import { MenuIcons } from 'enums/menuIcons';
import { IMenuIconProps } from 'interfaces/Props/IMenuIconProps';
import { theme } from 'styles/theme';

export default function NavMenuIcon({
  icon,
  color = theme.palette.system.navIconGray,
  active,
}: IMenuIconProps) {
  if (active) {
    color = theme.palette.system.skyBlue;
  }

  return (
    <>
      {(icon as MenuIcons) === MenuIcons.AMNBadge && (
        <svg
          id="Controls_icon_QR-Code"
          data-name="Controls/icon/QR-Code"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_3854"
            data-name="Rectangle 3854"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g
            id="Group_8831"
            data-name="Group 8831"
            transform="translate(9288 17020)"
          >
            <path
              id="Rectangle_3853"
              data-name="Rectangle 3853"
              d="M3,3V13H13V3H3M2,0H14a2,2,0,0,1,2,2V14a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
              transform="translate(-9287 -17019)"
              fill={color}
            />
            <path
              id="Rectangle_3855"
              data-name="Rectangle 3855"
              d="M3,3V13H13V3H3M2,0H14a2,2,0,0,1,2,2V14a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
              transform="translate(-9267 -17019)"
              fill={color}
            />
            <path
              id="Rectangle_3856"
              data-name="Rectangle 3856"
              d="M3,3V13H13V3H3M2,0H14a2,2,0,0,1,2,2V14a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
              transform="translate(-9287 -16999)"
              fill={color}
            />
            <circle
              id="Ellipse_1453"
              data-name="Ellipse 1453"
              cx="1.5"
              cy="1.5"
              r="1.5"
              transform="translate(-9280.297 -17012.297)"
              fill={color}
            />
            <circle
              id="Ellipse_1454"
              data-name="Ellipse 1454"
              cx="1.5"
              cy="1.5"
              r="1.5"
              transform="translate(-9260.703 -17012.297)"
              fill={color}
            />
            <circle
              id="Ellipse_1455"
              data-name="Ellipse 1455"
              cx="1.5"
              cy="1.5"
              r="1.5"
              transform="translate(-9280.297 -16992.703)"
              fill={color}
            />
            <rect
              id="Rectangle_3857"
              data-name="Rectangle 3857"
              width="6"
              height="3"
              rx="1.5"
              transform="translate(-9263.207 -16999.406)"
              fill={color}
            />
            <rect
              id="Rectangle_3860"
              data-name="Rectangle 3860"
              width="9"
              height="3"
              rx="1.5"
              transform="translate(-9260 -16986)"
              fill={color}
            />
            <rect
              id="Rectangle_3858"
              data-name="Rectangle 3858"
              width="5"
              height="3"
              rx="1.5"
              transform="translate(-9264.406 -16992) rotate(90)"
              fill={color}
            />
            <rect
              id="Rectangle_3859"
              data-name="Rectangle 3859"
              width="4"
              height="3"
              rx="1.5"
              transform="translate(-9256 -16990.219) rotate(180)"
              fill={color}
            />
            <rect
              id="Rectangle_3861"
              data-name="Rectangle 3861"
              width="6"
              height="3"
              rx="1.5"
              transform="translate(-9254 -16983) rotate(-90)"
              fill={color}
            />
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Assignments && (
        <svg
          id="Controls_icon_Jobs"
          data-name="Controls/icon/Jobs"
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2258"
            data-name="Rectangle 2258"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g
            id="Group_2851"
            data-name="Group 2851"
            transform="translate(-10.822 -9.771)"
          >
            <path
              id="Path_3709"
              data-name="Path 3709"
              d="M45.09,18.8H38.759v-2.33a2.717,2.717,0,0,0-2.731-2.7H23.615a2.718,2.718,0,0,0-2.731,2.7V18.8H14.552a2.717,2.717,0,0,0-2.731,2.7V41.075a2.717,2.717,0,0,0,2.731,2.7H45.09a2.717,2.717,0,0,0,2.731-2.7V21.5A2.717,2.717,0,0,0,45.09,18.8Zm-21.723-2.33a.25.25,0,0,1,.248-.245H36.028a.249.249,0,0,1,.248.245V18.8H23.367ZM45.338,41.075a.249.249,0,0,1-.248.245H14.552a.25.25,0,0,1-.248-.245V21.5a.25.25,0,0,1,.248-.245H45.09a.249.249,0,0,1,.248.245Z"
              fill={color}
            />
            <path
              id="Path_3710"
              data-name="Path 3710"
              d="M32.381,24.584H27.415V29.04H22.9v4.9h4.512V38.4h4.966V33.944h4.512v-4.9H32.381Z"
              transform="translate(-0.076 -0.206)"
              fill={color}
            />
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Contacts && (
        <svg
          id="Controls_icon_Contacts-People"
          data-name="Controls/icon/Contacts-People"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2340"
            data-name="Rectangle 2340"
            width="38"
            height="38"
            fill="none"
            opacity="0.002"
          />
          <path
            id="Path_3825"
            data-name="Path 3825"
            d="M36.262,23.335a6.83,6.83,0,0,0,1.75-4.611A6.226,6.226,0,0,0,32.1,12.239a6.071,6.071,0,0,0-5.773,5.08,5.46,5.46,0,0,0-4.771.044h0a6.088,6.088,0,0,0-5.788-5.124,6.226,6.226,0,0,0-5.915,6.485,6.83,6.83,0,0,0,1.75,4.611C9.6,24.2,5.93,26.292,5.93,30V30.6l.576.242c.778.315,1.5.673,2.214,1.01a15.655,15.655,0,0,0,5.476,1.835,5.445,5.445,0,0,0-.059.794v.608l.576.234c.778.322,1.5.673,2.205,1.017a14.291,14.291,0,0,0,6.611,1.9c2.43,0,5.482-.761,9.767-2.942l.508-.256v-.556a5.213,5.213,0,0,0-.08-.908h.011a26.49,26.49,0,0,0,7.7-2.767l.5-.256V30C41.93,26.292,38.258,24.2,36.262,23.335ZM32.1,14.069c2.229,0,4.046,2.086,4.046,4.655s-1.817,4.662-4.046,4.662a3.636,3.636,0,0,1-2.229-.776h0a6.7,6.7,0,0,0-1.81-4.026h0A4.358,4.358,0,0,1,32.1,14.069ZM26.211,19.4h0a4.871,4.871,0,0,1,1.817,3.879v.015a.779.779,0,0,1-.007.132,4.919,4.919,0,0,1-.546,2.189h0A4.142,4.142,0,0,1,25.1,27.749h0l-.239.073a3.245,3.245,0,0,1-.882.117,3.292,3.292,0,0,1-1-.154.994.994,0,0,1-.209-.066,4.164,4.164,0,0,1-2.243-2.027,5.1,5.1,0,0,1-.591-2.35v-.066a4.917,4.917,0,0,1,1.7-3.791,3.687,3.687,0,0,1,2.348-.864A3.636,3.636,0,0,1,26.211,19.4ZM15.764,14.069c2.221,0,4.031,2.064,4.046,4.619h0a6.709,6.709,0,0,0-1.7,3.828h0a3.669,3.669,0,0,1-2.348.871c-2.228,0-4.046-2.093-4.046-4.662S13.535,14.069,15.764,14.069ZM7.844,29.418c.464-2.73,4.068-4.267,5.212-4.684a8.544,8.544,0,0,0,2.707.593,8.38,8.38,0,0,0,2.475-.505h0a6.7,6.7,0,0,0,1.538,3.016h0A10.3,10.3,0,0,0,14.793,31.9l0,.011a13.387,13.387,0,0,1-5.239-1.7C9,29.952,8.443,29.681,7.844,29.418Zm9.9,5.286c-.546-.263-1.1-.534-1.7-.8a1.558,1.558,0,0,1,.034-.184H16.1a4.323,4.323,0,0,1,1.092-1.954l-.027,0,.013-.017a11.04,11.04,0,0,1,4.083-2.533,7.049,7.049,0,0,0,1.01.329l.015,0s0,.007,0,.01c.277.073.561.132.823.176a5.431,5.431,0,0,0,.875.088,5.9,5.9,0,0,0,.9-.1c.224-.037.456-.081.7-.139,0-.006,0-.011,0-.017a7.262,7.262,0,0,0,1.1-.355,10.706,10.706,0,0,1,4.18,2.657h.008a4.115,4.115,0,0,1,.979,1.859,2.151,2.151,0,0,1,.046.212C24.111,37.785,21.292,36.416,17.748,34.7Zm15.365-2.878h-.006l-.007-.014a10.419,10.419,0,0,0-4.918-3.966,6.729,6.729,0,0,0,1.537-2.989,8.448,8.448,0,0,0,2.378.468,8.544,8.544,0,0,0,2.707-.593c1.152.417,4.786,1.962,5.212,4.728A22.433,22.433,0,0,1,33.113,31.826Z"
            transform="translate(-4.93 -6.238)"
            fill={color}
          />
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Credentials && (
        <svg
          id="Controls_icon_Credentials"
          data-name="Controls/icon/Credentials"
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="27"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2270"
            data-name="Rectangle 2270"
            width="38"
            height="38"
            fill={color}
            opacity="0"
          />
          <g
            id="Group_8888"
            data-name="Group 8888"
            transform="translate(-307.884 -353.469)"
          >
            <path
              id="Path_6604"
              data-name="Path 6604"
              d="M337.49,390.462H317.246c-.046,0-.105,0-.164,0a3.208,3.208,0,0,1-3.193-3.037,3.431,3.431,0,0,1,0-.357V362.26a3.248,3.248,0,0,1,2.754-3.32c1.109-.252,2.245-.575,3.345-.887.421-.12.845-.24,1.267-.356q5.713-1.576,11.423-3.159l.072-.058.077-.012.9,0a3.636,3.636,0,0,1,2,1.155,3.2,3.2,0,0,1,.74,2.018c.006.326,0,.654,0,.995v.266h1.055c.044,0,.1,0,.159,0a3.223,3.223,0,0,1,3.2,3.395v24.777a3.212,3.212,0,0,1-3.008,3.389c-.063,0-.127.006-.19.006S337.552,390.466,337.49,390.462Zm-20.064-29.538a4.5,4.5,0,0,0-.488.026,1.142,1.142,0,0,0-.992.858,2.927,2.927,0,0,0-.048.646V386.91a4.539,4.539,0,0,0,.025.491,1.15,1.15,0,0,0,.851,1,3,3,0,0,0,.541.049l20.035,0a4.042,4.042,0,0,0,.474-.024,1.068,1.068,0,0,0,.955-.771,2.457,2.457,0,0,0,.087-.735q.011-6.129.005-12.234V362.5a4.712,4.712,0,0,0-.026-.525,1.139,1.139,0,0,0-.852-1,2.964,2.964,0,0,0-.55-.051Zm17.032-2.032,0-.224c.005-.342.011-.68-.011-1.017a1.144,1.144,0,0,0-1.135-1.158,1.126,1.126,0,0,0-.391.07c-1.92.528-3.817,1.055-5.714,1.584l-2.682.744Z"
              transform="translate(0 0)"
              fill={color}
            />
            <path
              id="Path_6605"
              data-name="Path 6605"
              d="M328.062,381.246a8.35,8.35,0,1,1,.005,0Zm-1.87-7.38a11.56,11.56,0,0,0,.8,3.955,5.78,5.78,0,0,0,.774,1.235.359.359,0,0,0,.3.175.337.337,0,0,0,.189-.059.342.342,0,0,0,.1-.1,3.668,3.668,0,0,0,.56-.787,9.029,9.029,0,0,0,.885-3.037c.049-.37.084-.736.119-1.108l.028-.283Zm5.786.007a14.871,14.871,0,0,1-.928,4.548,6.147,6.147,0,0,0,3.2-4.548Zm-10.12-.007a6.164,6.164,0,0,0,3.213,4.545,14.667,14.667,0,0,1-.929-4.545Zm12.408-2.056a6.162,6.162,0,0,0-3.185-4.521c.018.059.036.118.054.178.18.595.367,1.21.5,1.835.129.6.208,1.228.284,1.835.028.224.056.448.087.674Zm-4.312,0-.042-.376c-.053-.5-.105-.98-.187-1.46a7.422,7.422,0,0,0-1.142-3.108c-.121-.169-.315-.38-.519-.38s-.4.211-.528.39a6.528,6.528,0,0,0-.966,2.3,13.97,13.97,0,0,0-.384,2.637Zm-5.811,0a14.824,14.824,0,0,1,.937-4.557,6.2,6.2,0,0,0-3.2,4.557Z"
              transform="translate(-0.678 -1.119)"
              fill={color}
            />
            <path
              id="Path_6606"
              data-name="Path 6606"
              d="M320.536,386.484a1.029,1.029,0,0,1-1.018-.939,1.017,1.017,0,0,1,.917-1.062,2.573,2.573,0,0,1,.36-.025h14.1a2.891,2.891,0,0,1,.484.039.99.99,0,0,1,.84.979,1.01,1.01,0,0,1-.8.973,2.315,2.315,0,0,1-.374.03l-14.491,0-.014-.266Z"
              transform="translate(-0.656 -3.359)"
              fill={color}
            />
            <path
              id="Path_6607"
              data-name="Path 6607"
              d="M323.941,389.828a1.131,1.131,0,0,1-.918-.473.985.985,0,0,1-.154-.749.974.974,0,0,1,.416-.63,1,1,0,0,1,.216-.109,1.516,1.516,0,0,1,.489-.082h8.543a1.152,1.152,0,0,1,.9.365,1,1,0,0,1,.215.818,1.04,1.04,0,0,1-1.161.849h-3.718l-.514,0h-4.2A.659.659,0,0,1,323.941,389.828Z"
              transform="translate(-1.044 -3.731)"
              fill={color}
            />
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.TaskCenter && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="27"
          viewBox="0 0 24 24"
        >
          <g
            id="Group_14590"
            data-name="Group 14590"
            transform="translate(-23.999 -18)"
          >
            <g
              id="Controls-icon-Open_Tasks"
              data-name="Controls-icon-Open Tasks"
              transform="translate(24 18)"
            >
              <rect
                id="Rectangle_2270"
                data-name="Rectangle 2270"
                width="24"
                height="24"
                transform="translate(-0.001)"
                fill={color}
                opacity="0"
              />
              <g
                id="Group_14573"
                data-name="Group 14573"
                transform="translate(0.631 5.053)"
              >
                <g
                  id="Group_14569"
                  data-name="Group 14569"
                  transform="translate(0)"
                >
                  <g
                    id="Group_2962"
                    data-name="Group 2962"
                    transform="translate(7.955 1.299)"
                  >
                    <path
                      id="Path_3852"
                      data-name="Path 3852"
                      d="M40.651,21.106H26.977a.707.707,0,0,1,0-1.38H40.651a.707.707,0,0,1,0,1.38Z"
                      transform="translate(-26.423 -19.726)"
                      fill={color}
                    />
                  </g>
                  <g id="Group_2963" data-name="Group 2963">
                    <path
                      id="Path_3853"
                      data-name="Path 3853"
                      d="M19.7,22.293a.69.69,0,0,1-.488-.2l-1.238-1.237a.69.69,0,0,1,.976-.976l.75.75,2.11-2.11a.69.69,0,1,1,.976.975l-2.6,2.6A.69.69,0,0,1,19.7,22.293Z"
                      transform="translate(-17.775 -18.314)"
                      fill={color}
                    />
                  </g>
                  <g
                    id="Group_2964"
                    data-name="Group 2964"
                    transform="translate(7.955 6.054)"
                  >
                    <path
                      id="Path_3854"
                      data-name="Path 3854"
                      d="M40.651,26.275H26.977a.707.707,0,0,1,0-1.38H40.651a.707.707,0,0,1,0,1.38Z"
                      transform="translate(-26.423 -24.895)"
                      fill={color}
                    />
                  </g>
                  <g
                    id="Group_2965"
                    data-name="Group 2965"
                    transform="translate(0 4.754)"
                  >
                    <path
                      id="Path_3855"
                      data-name="Path 3855"
                      d="M19.7,27.462a.69.69,0,0,1-.488-.2l-1.238-1.237a.69.69,0,1,1,.976-.976l.75.75,2.11-2.111a.69.69,0,0,1,.976.976l-2.6,2.6A.69.69,0,0,1,19.7,27.462Z"
                      transform="translate(-17.775 -23.482)"
                      fill={color}
                    />
                  </g>
                  <g
                    id="Group_2966"
                    data-name="Group 2966"
                    transform="translate(7.955 10.809)"
                  >
                    <path
                      id="Path_3856"
                      data-name="Path 3856"
                      d="M40.651,31.444H26.977a.707.707,0,0,1,0-1.38H40.651a.707.707,0,0,1,0,1.38Z"
                      transform="translate(-26.423 -30.064)"
                      fill={color}
                    />
                  </g>
                  <g
                    id="Group_2967"
                    data-name="Group 2967"
                    transform="translate(0 9.509)"
                  >
                    <path
                      id="Path_3857"
                      data-name="Path 3857"
                      d="M19.7,32.631a.693.693,0,0,1-.488-.2L17.977,31.19a.69.69,0,0,1,.976-.975l.75.75,2.11-2.111a.69.69,0,1,1,.976.976l-2.6,2.6A.693.693,0,0,1,19.7,32.631Z"
                      transform="translate(-17.775 -28.651)"
                      fill={color}
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Edit && (
        <svg
          id="Controls_icon_Edit"
          data-name="Controls/icon/Edit"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
        >
          <g
            id="Group_2859"
            data-name="Group 2859"
            transform="translate(-11 -11)"
          >
            <rect
              id="Rectangle_2263"
              data-name="Rectangle 2263"
              width="38"
              height="38"
              transform="translate(11 11)"
              fill="none"
              opacity="0"
            />
            <path
              id="Path_3726"
              data-name="Path 3726"
              d="M52.606,21.519l-4.749-4.753a3.8,3.8,0,0,0-5.24,0L19.481,39.925A6.777,6.777,0,0,0,17.7,44.679l.21,4.445c.133,1.954.42,2.24,2.371,2.372l4.439.21c.1.007.2.011.3.011a6.844,6.844,0,0,0,4.448-1.794L52.6,26.764a3.717,3.717,0,0,0,0-5.245ZM46.126,28.48,40.9,23.25l.534-.534,5.225,5.23ZM24.946,48.343l-1.438-.1L21.156,45.89l-.1-1.438a3.485,3.485,0,0,1,.454-1.64l5.07,5.075A3.728,3.728,0,0,1,24.946,48.343Zm3.143-1.807-5.225-5.23L39.472,24.681l5.225,5.23ZM50.224,24.379l-2.134,2.136-5.225-5.23L45,19.148a.336.336,0,0,1,.238-.094.332.332,0,0,1,.238.1L50.224,23.9a.317.317,0,0,1,.1.237A.327.327,0,0,1,50.224,24.379Z"
              transform="translate(-5.688 -3.717)"
              fill={color}
            />
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.EducationTrainingCommunity && (
        <svg
          id="Controls_Icons_Graduate"
          data-name="Controls/Icons/Graduate"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2270"
            data-name="Rectangle 2270"
            width="38"
            height="38"
            fill={color}
            opacity="0"
          />
          <path
            id="Path_6613"
            data-name="Path 6613"
            d="M338.441,393.675a1.151,1.151,0,0,1-1.119-1.211v-.678c0-.432,0-.863-.013-1.293a.776.776,0,0,0-.192-.461c-.531-.552-1.071-1.1-1.611-1.638l-.783-.785a1.192,1.192,0,0,1,.011-1.955l.628-.633c.6-.6,1.2-1.206,1.792-1.814a.566.566,0,0,0,.157-.334q.014-3.728.008-7.458v-.931a.944.944,0,0,0-.009-.1l-.462.166c-.617.221-1.221.438-1.819.673a.493.493,0,0,0-.1.305c-.009,2.08-.016,4.159,0,6.238a1.776,1.776,0,0,1-.587,1.4,9.855,9.855,0,0,1-4.053,2.2,20.454,20.454,0,0,1-6.087.8c-.284,0-.568,0-.853-.01A18.224,18.224,0,0,1,317,385.01a8.945,8.945,0,0,1-2.908-1.769,1.91,1.91,0,0,1-.655-1.513c.019-1.282.018-2.564.016-3.847,0-.809,0-1.618,0-2.427a.332.332,0,0,0-.264-.382q-2.195-.806-4.388-1.63l-1.278-.478a1.155,1.155,0,0,1,0-2.241l5.671-2.068q5.338-1.946,10.674-3.9a1.32,1.32,0,0,1,.467-.085,1.9,1.9,0,0,1,.667.138c3.243,1.186,13.537,4.938,13.537,4.938q1.334.483,2.669.973a1.151,1.151,0,0,1,.8,1.5,1.175,1.175,0,0,1-.757.722l-.509.186c-.323.117-.645.235-.971.347-.148.051-.209.1-.209.271,0,0,.008,7.477.012,9.13a.568.568,0,0,0,.161.332c.354.362.713.723,1.07,1.083l.13.131c.358.36.716.722,1.069,1.088a5.279,5.279,0,0,1,.426.523l.219.293v.614l-.2.273a5.168,5.168,0,0,1-.44.543c-.347.361-.7.717-1.055,1.073-.4.4-.8.8-1.185,1.206a.778.778,0,0,0-.187.462c-.016.429-.014.859-.011,1.289v.681a1.146,1.146,0,0,1-1.125,1.2Zm-.028-5.651,1.376-1.386-1.341-1.354-1.379,1.385Zm-22.7-10.722c0,1.366,0,2.7-.008,4.037a.591.591,0,0,0,.259.529,7.13,7.13,0,0,0,2.533,1.242,20.668,20.668,0,0,0,5.655.8,21.833,21.833,0,0,0,4.813-.551,8.825,8.825,0,0,0,3.464-1.526.521.521,0,0,0,.225-.47c-.008-1.267-.008-2.536-.007-3.8v-1.471l-.272.092-2.213.8q-2.682.972-5.36,1.949a1.958,1.958,0,0,1-.678.133,1.6,1.6,0,0,1-.592-.114c-1.281-.492-2.57-.97-3.859-1.45l-3.964-1.476Zm-2.2-4.536q5.158,1.925,10.313,3.857a.87.87,0,0,0,.31.06,1.157,1.157,0,0,0,.4-.084l11.063-4.021,2-.733a1.773,1.773,0,0,0-.163-.072l-1.23-.45q-5.784-2.111-11.572-4.21a.811.811,0,0,0-.26-.041.936.936,0,0,0-.316.052q-4.152,1.5-8.3,3.021l-4.686,1.708Z"
            transform="translate(-305.654 -359.676)"
            fill={color}
          />
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Faq && (
        <svg
          id="Controls_icon_Help"
          data-name="Controls/icon/Help"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2352"
            data-name="Rectangle 2352"
            width="38"
            height="38"
            fill={color}
            opacity="0"
          />
          <g id="Group_8903" data-name="Group 8903">
            <path
              id="Ellipse_1456"
              data-name="Ellipse 1456"
              d="M17-1A18,18,0,0,1,29.728,29.728,18,18,0,0,1,4.272,4.272,17.882,17.882,0,0,1,17-1Zm0,32.727A14.727,14.727,0,1,0,2.273,17,14.744,14.744,0,0,0,17,31.727Z"
              transform="translate(2 2)"
              fill={color}
            />
            <path
              id="Path_6622"
              data-name="Path 6622"
              d="M14.357,19.095a1.637,1.637,0,0,1-.517-3.189c.98-.332,3.79-1.665,3.79-3.357a3.273,3.273,0,0,0-6.36-1.093,1.636,1.636,0,1,1-3.087-1.086A6.545,6.545,0,0,1,20.9,12.551c0,1.33-.552,3.287-3.183,5.041a13.277,13.277,0,0,1-2.845,1.418A1.636,1.636,0,0,1,14.357,19.095Z"
              transform="translate(4.512 3.178)"
              fill={color}
            />
            <path
              id="Line_210"
              data-name="Line 210"
              d="M.653,2.273H.636A1.636,1.636,0,0,1,.636-1H.653a1.636,1.636,0,1,1,0,3.273Z"
              transform="translate(18.363 26.545)"
              fill={color}
            />
          </g>
        </svg>
      )}
      {/* Hiding for Minimum Viable Product requirements for US 31532*/}
      {/* {(icon as MenuIcons) === MenuIcons.Feedback && (
        <svg
          id="Controls_icons_Thumbs-Up"
          data-name="Controls/icons/Thumbs-Up"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2366"
            data-name="Rectangle 2366"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <path
            id="Path_3891"
            data-name="Path 3891"
            d="M-46.267,49.682H-70.394a4.744,4.744,0,0,1-4.772-4.7V33.345a4.744,4.744,0,0,1,4.772-4.7h4.151L-59.864,14.5a1.4,1.4,0,0,1,1.278-.819,6.421,6.421,0,0,1,6.461,6.366v5.268h8.146a4.706,4.706,0,0,1,.756.054A4.755,4.755,0,0,1-40.1,27.232a4.616,4.616,0,0,1,.874,3.495l-2.327,14.96A4.771,4.771,0,0,1-46.267,49.682Zm-17.667-2.758h17.651a1.976,1.976,0,0,0,1.966-1.654l2.329-14.96a1.911,1.911,0,0,0-.363-1.444,1.961,1.961,0,0,0-1.292-.769,2.222,2.222,0,0,0-.319-.023h-9.563a1.388,1.388,0,0,1-1.4-1.379V20.048a3.626,3.626,0,0,0-2.8-3.507l-6.212,13.771ZM-70.394,31.4a1.962,1.962,0,0,0-1.974,1.946V44.979a1.962,1.962,0,0,0,1.974,1.945h3.662V31.4Z"
            transform="translate(76.166 -12.682)"
            fill={color}
          />
        </svg>
      )} */}
      {(icon as MenuIcons) === MenuIcons.Home && (
        <svg
          id="Controls_Icon_Home"
          data-name="Controls/Icon/Home"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
          style={{ width: '24px', height: '24px' }}
        >
          <rect
            id="Rectangle_2257"
            data-name="Rectangle 2257"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g
            id="Group_2849"
            data-name="Group 2849"
            transform="translate(-12.367 -11.951)"
          >
            <path
              id="Path_3707"
              data-name="Path 3707"
              d="M48.9,27.239,33.479,13.73a3.256,3.256,0,0,0-4.225,0L13.83,27.239a1.355,1.355,0,0,0,1.778,2.046l.577-.505V44.964a2.985,2.985,0,0,0,2.976,2.987H43.572a2.984,2.984,0,0,0,2.976-2.987V28.781l.577.505A1.356,1.356,0,0,0,48.9,27.239Zm-14.627,18H28.456V35.172h5.821Zm9.565-.272a.274.274,0,0,1-.271.272H36.982V33.815a1.355,1.355,0,0,0-1.353-1.358H27.1a1.356,1.356,0,0,0-1.353,1.358V45.236H19.161a.274.274,0,0,1-.271-.272V26.411L31.034,15.775a.574.574,0,0,1,.667,0L43.842,26.411Z"
              transform="translate(0 0)"
              fill={color}
            />
            <path
              id="Path_3708"
              data-name="Path 3708"
              d="M25.771,24.074a1.354,1.354,0,0,0,1.353,1.358h6.448a1.358,1.358,0,0,0,0-2.715H27.124A1.355,1.355,0,0,0,25.771,24.074Z"
              transform="translate(1.019 0.841)"
              fill={color}
            />
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.HousingTravel && (
        <svg
          id="Controls_icon_Traveller"
          data-name="Controls/icon/Traveller"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2263"
            data-name="Rectangle 2263"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <path
            id="Path_6630"
            data-name="Path 6630"
            d="M-1228.269-148.141a5.472,5.472,0,0,1,1.888.789,4.229,4.229,0,0,1,.519,6.458c-2.063,2.03-4.164,4.022-6.262,6.015a.657.657,0,0,0-.212.8q2.616,7.851,5.21,15.71a.475.475,0,0,1-.128.576c-1.466,1.451-2.92,2.914-4.378,4.373-.081.081-.166.158-.269.255l-8.475-13.776c-.592.57-1.154,1.113-1.719,1.655-1.327,1.274-2.659,2.543-3.977,3.827a.592.592,0,0,0-.149.446c.2,1.318.43,2.632.637,3.95a.492.492,0,0,1-.1.372q-2.224,2.251-4.467,4.482a.614.614,0,0,1-.111.065c-.377-1.077-.751-2.146-1.126-3.215-.487-1.39-.971-2.781-1.468-4.167a.561.561,0,0,0-.269-.321c-2.488-.88-4.981-1.746-7.473-2.615v-.07c.1-.082.2-.157.288-.246,1.4-1.4,2.8-2.8,4.2-4.2a.616.616,0,0,1,.446-.177q1.958.294,3.908.641a.5.5,0,0,0,.518-.166c1.089-1.147,2.187-2.285,3.281-3.427.712-.743,1.422-1.488,2.162-2.262l-13.753-8.479c.048-.061.067-.091.092-.116,1.531-1.534,3.066-3.064,4.589-4.606.175-.177.315-.122.5-.061q7.927,2.626,15.853,5.254a.439.439,0,0,0,.541-.133q2.006-2.118,4.03-4.218c.389-.406.8-.8,1.166-1.218a5.833,5.833,0,0,1,3.317-2.2Zm-14.184,15.343c-.085.1-.143.167-.207.233q-3.866,4.036-7.727,8.078a.745.745,0,0,1-.764.241c-1.277-.225-2.558-.429-3.839-.634a.335.335,0,0,0-.251.048c-.485.469-.96.949-1.471,1.458.158.062.262.107.368.144,1.586.558,3.171,1.12,4.761,1.666a.588.588,0,0,1,.415.411c.547,1.592,1.108,3.179,1.666,4.767.04.114.086.225.148.388.508-.513.973-.975,1.423-1.45a.41.41,0,0,0,.069-.307c-.2-1.282-.407-2.565-.63-3.844a.719.719,0,0,1,.243-.734c1.137-1.066,2.253-2.153,3.378-3.232l4.924-4.726,8.452,13.738c.613-.614,1.18-1.2,1.774-1.766a.539.539,0,0,0,.158-.663q-2.629-7.9-5.241-15.807a.5.5,0,0,1,.157-.6c.931-.875,1.847-1.764,2.768-2.65,1.5-1.446,3.013-2.885,4.506-4.341a1.99,1.99,0,0,0,.545-2.129,2.017,2.017,0,0,0-1.672-1.47,2.052,2.052,0,0,0-1.933.672q-3.468,3.615-6.931,7.235a.47.47,0,0,1-.576.138q-3.571-1.2-7.148-2.376-4.34-1.439-8.678-2.883a.488.488,0,0,0-.607.143c-.362.4-.756.768-1.137,1.15l-.652.656Z"
            transform="translate(1261.601 149.141)"
            fill={color}
          />
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Jobs && (
        <svg
          id="Controls_Icon_Search"
          data-name="Controls/Icon/Search"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
          style={{ width: '24px', height: '24px' }}
        >
          <rect
            id="Rectangle_2254"
            data-name="Rectangle 2254"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <path
            id="Path_2934"
            data-name="Path 2934"
            d="M49.417,46.4l-4.1-4.105L40.3,37.284a14.723,14.723,0,1,0-2.774,2.772l9.119,9.119A1.96,1.96,0,0,0,49.417,46.4ZM16.794,28.411A11.86,11.86,0,1,1,28.654,40.272,11.874,11.874,0,0,1,16.794,28.411Z"
            transform="translate(-12.992 -12.75)"
            fill={color}
          />
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Menu && (
        <svg
          id="Controls_icon_Rearrange-Hamburger"
          data-name="Controls/icon/Rearrange-Hamburger"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
          style={{ width: '24px', height: '24px' }}
        >
          <rect
            id="Rectangle_2304"
            data-name="Rectangle 2304"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g id="menu_1_" data-name="menu (1)" transform="translate(1 7)">
            <path
              id="Line_210"
              data-name="Line 210"
              d="M32.864,1.773H.136a1.636,1.636,0,0,1,0-3.273H32.864a1.636,1.636,0,1,1,0,3.273Z"
              transform="translate(1.5 12.363)"
              fill={color}
            />
            <path
              id="Line_211"
              data-name="Line 211"
              d="M32.864,1.773H.136a1.636,1.636,0,0,1,0-3.273H32.864a1.636,1.636,0,1,1,0,3.273Z"
              transform="translate(1.5 0.5)"
              fill={color}
            />
            <path
              id="Line_212"
              data-name="Line 212"
              d="M32.864,1.773H.136a1.636,1.636,0,0,1,0-3.273H32.864a1.636,1.636,0,1,1,0,3.273Z"
              transform="translate(1.5 24.226)"
              fill={color}
            />
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Notifications && (
        <svg
          id="Controls_icon_Notifications"
          data-name="Controls/icon/Notifications"
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2259"
            data-name="Rectangle 2259"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <path
            id="Path_3711"
            data-name="Path 3711"
            d="M49.487,37.673c-1.934-.963-2.915-3.047-2.915-6.192,0-14.873-7.768-17.995-14.284-17.995S18,16.608,18,31.481c0,3.146-.981,5.23-2.916,6.191a1.448,1.448,0,0,0-.8,1.3V45.36A1.44,1.44,0,0,0,15.722,46.8H28.629a3.836,3.836,0,0,0,7.316,0H48.852a1.44,1.44,0,0,0,1.435-1.444V38.967A1.442,1.442,0,0,0,49.487,37.673Zm-17.2-21.3c7.679,0,11.413,4.941,11.413,15.106a10.461,10.461,0,0,0,2.14,6.927H18.734a10.458,10.458,0,0,0,2.139-6.927C20.873,21.316,24.607,16.375,32.288,16.375Zm-15.13,27.54V40.592a1.114,1.114,0,0,0,.5.127h28.9a1.13,1.13,0,0,0,.854-.4v3.6Z"
            transform="translate(-13.287 -12.486)"
            fill={color}
          />
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Pay && (
        <svg
          id="Controls_icon_Pay"
          data-name="Controls/icon/Pay"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2352"
            data-name="Rectangle 2352"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g
            id="Group_2981"
            data-name="Group 2981"
            transform="translate(-11.332 -11.332)"
          >
            <g
              id="Group_2980"
              data-name="Group 2980"
              transform="translate(12.332 12.332)"
            >
              <path
                id="Path_3863"
                data-name="Path 3863"
                d="M30.331,48.331a18,18,0,1,1,18-18A18.02,18.02,0,0,1,30.331,48.331Zm0-33.452A15.453,15.453,0,1,0,45.785,30.331,15.47,15.47,0,0,0,30.331,14.879Z"
                transform="translate(-12.332 -12.332)"
                fill={color}
              />
            </g>
            <g
              id="Group_1759"
              data-name="Group 1759"
              transform="translate(25.477 20.562)"
            >
              <g id="Group_1758" data-name="Group 1758">
                <path
                  id="Path_814"
                  data-name="Path 814"
                  d="M31.081,29.179H29.114a2.032,2.032,0,0,1-.1-4.063c.033,0,.065,0,.1,0h3.924a.921.921,0,1,0,.16-1.836.839.839,0,0,0-.16,0H31.007V21.253a.921.921,0,0,0-1.836,0v2.031h-.066a3.867,3.867,0,0,0-.007,7.733h1.983a2.032,2.032,0,0,1,0,4.063H27.148a.921.921,0,1,0-.159,1.836.829.829,0,0,0,.159,0H29.18v2.032a.921.921,0,0,0,1.836.159,1.035,1.035,0,0,0,0-.159V36.917h.065a3.867,3.867,0,0,0,0-7.733Z"
                  transform="translate(-25.235 -20.411)"
                  fill={color}
                />
              </g>
            </g>
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.PayStatements && (
        <svg
          id="Controls_icon_Pay"
          data-name="Controls/icon/Pay"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2352"
            data-name="Rectangle 2352"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g
            id="Group_2981"
            data-name="Group 2981"
            transform="translate(-11.332 -11.332)"
          >
            <g
              id="Group_2980"
              data-name="Group 2980"
              transform="translate(12.332 12.332)"
            >
              <path
                id="Path_3863"
                data-name="Path 3863"
                d="M30.331,48.331a18,18,0,1,1,18-18A18.02,18.02,0,0,1,30.331,48.331Zm0-33.452A15.453,15.453,0,1,0,45.785,30.331,15.47,15.47,0,0,0,30.331,14.879Z"
                transform="translate(-12.332 -12.332)"
                fill={color}
              />
            </g>
            <g
              id="Group_1759"
              data-name="Group 1759"
              transform="translate(25.477 20.562)"
            >
              <g id="Group_1758" data-name="Group 1758">
                <path
                  id="Path_814"
                  data-name="Path 814"
                  d="M31.081,29.179H29.114a2.032,2.032,0,0,1-.1-4.063c.033,0,.065,0,.1,0h3.924a.921.921,0,1,0,.16-1.836.839.839,0,0,0-.16,0H31.007V21.253a.921.921,0,0,0-1.836,0v2.031h-.066a3.867,3.867,0,0,0-.007,7.733h1.983a2.032,2.032,0,0,1,0,4.063H27.148a.921.921,0,1,0-.159,1.836.829.829,0,0,0,.159,0H29.18v2.032a.921.921,0,0,0,1.836.159,1.035,1.035,0,0,0,0-.159V36.917h.065a3.867,3.867,0,0,0,0-7.733Z"
                  transform="translate(-25.235 -20.411)"
                  fill={color}
                />
              </g>
            </g>
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.PrivacyPolicy && (
        <svg
          id="Controls_icon_Privacy-Policy"
          data-name="Controls/icon/Privacy-Policy"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2304"
            data-name="Rectangle 2304"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g
            id="Group_8902"
            data-name="Group 8902"
            transform="translate(-419.27 -600.438)"
          >
            <path
              id="Path_6621"
              data-name="Path 6621"
              d="M435.418,618.944c0-.807-.006-1.576,0-2.345a3.683,3.683,0,0,1,2.544-3.474,3.725,3.725,0,0,1,4.9,3.407c.019.791,0,1.582,0,2.418.2,0,.36-.007.522,0a1.2,1.2,0,0,1,1.2,1.177c.018,1.9.055,3.794-.012,5.688A3.432,3.432,0,0,1,441.3,629.1a35.125,35.125,0,0,1-4.615-.04,3.443,3.443,0,0,1-2.995-3.289c-.019-1.819-.01-3.638-.008-5.457a1.237,1.237,0,0,1,1.376-1.368C435.161,618.943,435.26,618.944,435.418,618.944Zm.264,2c0,1.5,0,2.965,0,4.43a1.578,1.578,0,0,0,1.741,1.749q1.712.009,3.425,0a2.4,2.4,0,0,0,.591-.061,1.549,1.549,0,0,0,1.144-1.624c.01-1.423,0-2.844,0-4.267a1.628,1.628,0,0,0-.032-.225Zm5.158-2.017c.008-.115.02-.2.018-.287-.011-.749.012-1.5-.047-2.245a1.652,1.652,0,0,0-1.619-1.467,1.615,1.615,0,0,0-1.694,1.294,25.911,25.911,0,0,0-.022,2.7Z"
              transform="translate(-2.343 -0.527)"
              fill={color}
            />
            <g
              id="Group_2856"
              data-name="Group 2856"
              transform="translate(425.27 601.437)"
            >
              <path
                id="Path_3718"
                data-name="Path 3718"
                d="M449.632,601.437H434.783a5.611,5.611,0,0,0-3.311,1.252l-4.723,4.169a4.825,4.825,0,0,0-1.479,3.274v24.682a2.634,2.634,0,0,0,2.638,2.624h21.724a2.634,2.634,0,0,0,2.638-2.624V604.058A2.634,2.634,0,0,0,449.632,601.437Zm-16.568,3.032a1.987,1.987,0,0,1,.348-.235v4.227h-4.867Zm16.811,30.344a.243.243,0,0,1-.24.239H427.91a.243.243,0,0,1-.24-.239V610.847h6.944a1.2,1.2,0,0,0,1.2-1.193v-5.832h13.819a.242.242,0,0,1,.24.239Z"
                transform="translate(-427.27 -601.437)"
                fill={color}
              />
            </g>
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Preferences && (
        <svg
          id="Controls_icon_Settings"
          data-name="Controls/icon/Settings"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2309"
            data-name="Rectangle 2309"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g
            id="Group_10809"
            data-name="Group 10809"
            transform="translate(-11 -11)"
          >
            <path
              id="Path_3760"
              data-name="Path 3760"
              d="M29.274,46.32a18.119,18.119,0,0,1-4.547-.579,1.194,1.194,0,0,1-.809-1.61,3.3,3.3,0,0,0-1.409-4.11,3.344,3.344,0,0,0-4.279.834,1.2,1.2,0,0,1-.879.46,1.24,1.24,0,0,1-.926-.354,17.467,17.467,0,0,1-4.57-7.871,1.2,1.2,0,0,1,1-1.5,3.3,3.3,0,0,0-.009-6.538,1.194,1.194,0,0,1-1-1.5,18,18,0,0,1,4.581-7.873,1.219,1.219,0,0,1,.927-.352,1.2,1.2,0,0,1,.878.46,3.34,3.34,0,0,0,4.279.835,3.3,3.3,0,0,0,1.412-4.1,1.193,1.193,0,0,1,.809-1.608,18.211,18.211,0,0,1,9.146-.01,1.206,1.206,0,0,1,.772.624,1.191,1.191,0,0,1,.037.987,3.3,3.3,0,0,0,1.409,4.11,3.342,3.342,0,0,0,4.279-.834,1.2,1.2,0,0,1,.878-.46,1.176,1.176,0,0,1,.927.354,17.48,17.48,0,0,1,4.57,7.871,1.2,1.2,0,0,1-1,1.5,3.3,3.3,0,0,0,.01,6.537,1.2,1.2,0,0,1,.842.525,1.192,1.192,0,0,1,.156.976,17.994,17.994,0,0,1-4.581,7.873,1.227,1.227,0,0,1-.927.353,1.2,1.2,0,0,1-.878-.461,3.341,3.341,0,0,0-4.279-.835,3.3,3.3,0,0,0-1.412,4.1,1.194,1.194,0,0,1-.809,1.609A18.264,18.264,0,0,1,29.274,46.32Zm-2.762-2.635a15.742,15.742,0,0,0,5.576-.009,5.708,5.708,0,0,1,2.8-5.727,5.771,5.771,0,0,1,6.389.45,15.63,15.63,0,0,0,2.8-4.8,5.676,5.676,0,0,1-.008-10.557,14.772,14.772,0,0,0-2.788-4.8,5.778,5.778,0,0,1-6.389.449,5.706,5.706,0,0,1-2.8-5.735,15.809,15.809,0,0,0-5.576.008,5.708,5.708,0,0,1-2.8,5.728,5.771,5.771,0,0,1-6.389-.449,15.6,15.6,0,0,0-2.8,4.8A5.676,5.676,0,0,1,14.535,33.6a14.763,14.763,0,0,0,2.788,4.8,5.774,5.774,0,0,1,6.389-.45A5.706,5.706,0,0,1,26.513,43.685Z"
              transform="translate(1.199 1.68)"
              fill={color}
            />
            <path
              id="Path_3761"
              data-name="Path 3761"
              d="M29.684,37.3a8.556,8.556,0,0,1-2.215-.293,8.5,8.5,0,1,1,9.563-12.455h0A8.5,8.5,0,0,1,29.684,37.3Zm-.025-14.594a6.117,6.117,0,1,0,1.588.211A6.067,6.067,0,0,0,29.659,22.711Z"
              transform="translate(0.831 1.695)"
              fill={color}
            />
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Promotions && (
        <svg
          id="Promotion_icon"
          data-name="Promotion icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <g id="Group_10472" data-name="Group 10472">
            <rect
              id="Rectangle_5399"
              data-name="Rectangle 5399"
              width="24"
              height="24"
              fill="none"
            />
          </g>
          <g id="Promotion" transform="translate(2 -26.933)">
            <g
              id="Group_13349"
              data-name="Group 13349"
              transform="translate(0 29.933)"
            >
              <path
                id="Path_26151"
                data-name="Path 26151"
                d="M17.559,34.14V30.922a.989.989,0,0,0-1.474-.862,23.016,23.016,0,0,1-9.6,2.883c-.026,0-3.1.015-3.1.015a1.511,1.511,0,0,0-1.5,1.332H1.253A1.254,1.254,0,0,0,0,35.543V38.3a1.254,1.254,0,0,0,1.253,1.253h.631a1.513,1.513,0,0,0,.89,1.2l2.246,6.2a.983.983,0,0,0,.921.645H8.194a.98.98,0,0,0,.921-1.315L7.186,40.958a22.985,22.985,0,0,1,8.9,2.82.983.983,0,0,0,.986-.01.979.979,0,0,0,.488-.852V39.7a2.8,2.8,0,0,0,0-5.557ZM1.873,38.583h-.62A.287.287,0,0,1,.966,38.3V35.543a.287.287,0,0,1,.287-.287h.62Zm1.288,1.284a.544.544,0,0,1-.322-.5v-4.9h0a.544.544,0,0,1,.543-.543h2.63v5.989l-2.665,0A.507.507,0,0,1,3.161,39.867Zm5.045,6.743a.011.011,0,0,1,0,.013.011.011,0,0,1-.011.006H5.94a.014.014,0,0,1-.013-.008L3.848,40.88H6.13Zm8.386-3.694a.018.018,0,0,1-.01.019.022.022,0,0,1-.026,0,23.953,23.953,0,0,0-9.577-2.967v-6.1A23.96,23.96,0,0,0,16.556,30.9a.023.023,0,0,1,.026,0,.017.017,0,0,1,.01.019Zm.966-4.2v-3.6a1.836,1.836,0,0,1,0,3.6Z"
                transform="translate(0 -29.933)"
                fill="#809eb4"
                stroke="#809eb4"
                strokeWidth="0.5"
              />
            </g>
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Profile && (
        <svg
          id="Controls_icon_Profile"
          data-name="Controls/icon/Profile"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
        >
          <g
            id="Group_2861"
            data-name="Group 2861"
            transform="translate(-11 -11)"
          >
            <rect
              id="Rectangle_2264"
              data-name="Rectangle 2264"
              width="38"
              height="38"
              transform="translate(11 11)"
              fill="none"
              opacity="0"
            />
            <g
              id="Group_2860"
              data-name="Group 2860"
              transform="translate(-0.332 -0.332)"
            >
              <path
                id="Path_3727"
                data-name="Path 3727"
                d="M30.332,12.332a18,18,0,1,0,18,18A18.02,18.02,0,0,0,30.332,12.332ZM42.032,40.4c-1.706-4.482-8.106-6.474-8.106-6.474a9.307,9.307,0,0,1-3.594.936,9.308,9.308,0,0,1-3.6-.936s-6.4,1.993-8.106,6.473a15.453,15.453,0,1,1,23.4,0Z"
                fill={color}
              />
              <ellipse
                id="Ellipse_600"
                data-name="Ellipse 600"
                cx="6.784"
                cy="7.757"
                rx="6.784"
                ry="7.757"
                transform="translate(23.548 18.026)"
                fill={color}
              />
            </g>
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.RewardsRecognition && (
        <svg
          id="Controls_Icon_Star"
          data-name="Controls/Icon/Star"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2366"
            data-name="Rectangle 2366"
            width="38"
            height="38"
            fill="none"
          />
          <path
            id="FontAwsome_star_"
            data-name="FontAwsome (star)"
            d="M54.656,11.71l-9.831-1.456L40.431,1.2a2.14,2.14,0,0,0-3.862,0l-4.394,9.05L22.343,11.71a2.2,2.2,0,0,0-1.191,3.732l7.113,7.04-1.682,9.945a2.159,2.159,0,0,0,3.122,2.3l8.795-4.7,8.795,4.7a2.161,2.161,0,0,0,3.122-2.3l-1.682-9.945,7.113-7.04a2.2,2.2,0,0,0-1.191-3.732Zm-9.387,9.624,1.595,9.46L38.5,26.331l-8.364,4.463,1.595-9.46-6.769-6.7,9.353-1.381L38.5,4.643l4.185,8.612,9.353,1.381-6.769,6.7Z"
            transform="translate(-19.5 2.012)"
            fill={color}
          />
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Reimbursements && (
        <svg
          id="Controls_Icons_Reimbursement"
          data-name="Controls/Icons/Reimbursement"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2270"
            data-name="Rectangle 2270"
            width="38"
            height="38"
            fill="#003c69"
            opacity="0"
          />
          <g
            id="Group_8895"
            data-name="Group 8895"
            transform="translate(-428.478 -369.287)"
          >
            <path
              id="Path_6610"
              data-name="Path 6610"
              d="M447.567,406.287a17.994,17.994,0,0,1-16.452-10.5,18.274,18.274,0,0,1-1.581-8.994,17.892,17.892,0,0,1,14.038-16.057,19.872,19.872,0,0,1,4.1-.444,17.787,17.787,0,0,1,11.174,4.04l1.075.793v-1.609c0-.422,0-.818,0-1.214a1.343,1.343,0,0,1,1.354-1.376,1.291,1.291,0,0,1,1.331,1.329q.036,3.4.016,6.806a1.27,1.27,0,0,1-1.214,1.229q-2.8.039-5.6.041l-1.165,0a1.337,1.337,0,1,1-.033-2.672c.463-.023.928-.025,1.392-.027l.719-.007a1.1,1.1,0,0,0,.655-.212l.59-.411-.581-.425-.459-.346c-.344-.259-.688-.519-1.048-.754a15.328,15.328,0,1,0-11.515,27.821,16.061,16.061,0,0,0,3.116.309,15.285,15.285,0,0,0,15.012-12.253,13.929,13.929,0,0,0,.238-4.433,1.473,1.473,0,0,1,.835-1.7,1.361,1.361,0,0,1,.489-.094,1.384,1.384,0,0,1,1.349,1.3,17.916,17.916,0,0,1-10.338,18.18A17.357,17.357,0,0,1,447.567,406.287Z"
              fill={color}
            />
            <path
              id="Path_814"
              data-name="Path 814"
              d="M448.032,387.1h-1.87a1.933,1.933,0,0,1-.093-3.864h3.825a.876.876,0,1,0,.151-1.746h0a.746.746,0,0,0-.151,0H447.96v-1.933a.876.876,0,0,0-1.747,0v1.933h-.064a3.684,3.684,0,0,0,0,7.355h1.887a1.933,1.933,0,0,1,0,3.863h-3.747a.876.876,0,1,0-.151,1.746.746.746,0,0,0,.151,0h1.934v1.933a.877.877,0,0,0,1.747.151h0a.926.926,0,0,0,0-.151v-1.933h.062a3.684,3.684,0,0,0,0-7.355Z"
              transform="translate(0.387 0.242)"
              fill={color}
            />
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Resources && (
        <svg
          id="Controls_icon_Document-Edit"
          data-name="Controls/icon/Document-Edit"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2342"
            data-name="Rectangle 2342"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g
            id="Group_2943"
            data-name="Group 2943"
            transform="translate(-11, -9.441)"
          >
            <g
              id="Group_2942"
              data-name="Group 2942"
              transform="translate(15.989 10.441)"
            >
              <path
                id="Path_3832"
                data-name="Path 3832"
                d="M40.934,18.722a1.2,1.2,0,0,0,1.2-1.2V12.851a2.411,2.411,0,0,0-2.406-2.41H25.03a4.751,4.751,0,0,0-2.906,1.129L17.27,16.009a4.308,4.308,0,0,0-1.281,2.911V44.031a2.41,2.41,0,0,0,2.4,2.41H39.726a2.411,2.411,0,0,0,2.406-2.41V37.4a1.2,1.2,0,1,0-2.4,0l-.01,6.639-21.341-.01V19.865h6.661a1.2,1.2,0,0,0,1.2-1.2V12.842l13.492.009v4.671A1.2,1.2,0,0,0,40.934,18.722Zm-21.7-1.258,4.507-4.122c.028-.025.074-.049.108-.074v4.2Z"
                transform="translate(-15.989 -10.441)"
                fill={color}
              />
              <path
                id="Path_3833"
                data-name="Path 3833"
                d="M31.3,28.08H23.86a1.2,1.2,0,0,1,0-2.4H31.3a1.2,1.2,0,0,1,0,2.4Z"
                transform="translate(-16.266 -11.049)"
                fill={color}
              />
              <path
                id="Path_3834"
                data-name="Path 3834"
                d="M27.511,33.733H23.86a1.2,1.2,0,0,1,0-2.4h3.651a1.2,1.2,0,0,1,0,2.4Z"
                transform="translate(-16.266 -11.274)"
                fill={color}
              />
              <path
                id="Path_3835"
                data-name="Path 3835"
                d="M26.168,39.387H23.86a1.2,1.2,0,0,1,0-2.4h2.308a1.2,1.2,0,0,1,0,2.4Z"
                transform="translate(-16.266 -11.499)"
                fill={color}
              />
              <path
                id="Path_3836"
                data-name="Path 3836"
                d="M43.48,23.435"
                transform="translate(-17.13 -10.959)"
                fill={color}
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="Path_3837"
                data-name="Path 3837"
                d="M47.847,22.575,46.316,21a2.63,2.63,0,0,0-3.695,0L32.61,31.308h0a7.363,7.363,0,0,0-1.628,2.948l-.412,1.689a2.131,2.131,0,0,0,.465,2.007,2.038,2.038,0,0,0,1.512.627,2.535,2.535,0,0,0,.46-.043l1.8-.327a6.375,6.375,0,0,0,3.03-1.616L47.846,26.285A2.682,2.682,0,0,0,47.847,22.575ZM34.381,35.848,33,36.1l.31-1.269a4.3,4.3,0,0,1,.416-.983l1.593,1.64A3.49,3.49,0,0,1,34.381,35.848Zm2.067-1.265-1.836-1.891,7.314-7.532,1.836,1.89Zm9.681-9.971-1.364,1.4-1.836-1.89,1.411-1.453a.175.175,0,0,1,.258,0l1.532,1.577A.275.275,0,0,1,46.128,24.612Z"
                transform="translate(-16.591 -10.832)"
                fill={color}
              />
              <path
                id="Path_3838"
                data-name="Path 3838"
                d="M33.076,35.632"
                transform="translate(-16.698 -11.445)"
                fill={color}
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </g>
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.ShareAndRefer && (
        <svg
          id="Controls_icon_Share"
          data-name="Controls/icon/Share"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2310"
            data-name="Rectangle 2310"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g
            id="Group_5858"
            data-name="Group 5858"
            transform="translate(-277.742 -403.303)"
          >
            <path
              id="Path_3763"
              data-name="Path 3763"
              d="M297.783,404.656a1.453,1.453,0,0,0-.428-.26l0,0c-.007-.005-.02,0-.029-.005a1.6,1.6,0,0,0-.469-.084,1.515,1.515,0,0,0-.154.011,2,2,0,0,0-.5.11,1.464,1.464,0,0,0-.434.261l-7.506,6.788a1.235,1.235,0,0,0,0,1.869,1.573,1.573,0,0,0,2.067,0l5.011-4.533,0,17.063a1.469,1.469,0,0,0,2.922.047v-17.11l5.011,4.533a1.573,1.573,0,0,0,2.067,0,1.235,1.235,0,0,0,0-1.869l-7.506-6.789C297.815,404.671,297.8,404.668,297.783,404.656Z"
              transform="translate(0.452 0)"
              fill={color}
            />
            <path
              id="Path_4883"
              data-name="Path 4883"
              d="M311.333,416.033h-.006a1.367,1.367,0,0,0-1.409,1.32v17.683a.277.277,0,0,1-.282.264h-24.8a.278.278,0,0,1-.282-.264v-9.61h.006v-8.071a1.366,1.366,0,0,0-1.409-1.322h-.006a1.367,1.367,0,0,0-1.409,1.32v8.074h.006v9.61a3.012,3.012,0,0,0,3.1,2.908h24.8a3.012,3.012,0,0,0,3.1-2.908V417.355A1.366,1.366,0,0,0,311.333,416.033Z"
              transform="translate(0 2.36)"
              fill={color}
            />
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.SkillsChecklist && (
        <svg
          id="Controls_icon_Skill-Checklist"
          data-name="Controls/icon/Skill-Checklist"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2258"
            data-name="Rectangle 2258"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g
            id="Group_2888"
            data-name="Group 2888"
            transform="translate(-10.718 -9.32)"
          >
            <path
              id="Path_3760"
              data-name="Path 3760"
              d="M29.274,46.32a18.118,18.118,0,0,1-4.547-.579,1.194,1.194,0,0,1-.809-1.61,3.3,3.3,0,0,0-1.409-4.11,3.344,3.344,0,0,0-4.279.834,1.2,1.2,0,0,1-.879.46,1.24,1.24,0,0,1-.926-.354,17.467,17.467,0,0,1-4.57-7.871,1.2,1.2,0,0,1,1-1.5,3.3,3.3,0,0,0-.009-6.538,1.194,1.194,0,0,1-1-1.5,18,18,0,0,1,4.581-7.873,1.219,1.219,0,0,1,.927-.352,1.2,1.2,0,0,1,.878.46,3.34,3.34,0,0,0,4.279.835,3.3,3.3,0,0,0,1.412-4.1,1.193,1.193,0,0,1,.809-1.608,18.211,18.211,0,0,1,9.146-.01,1.206,1.206,0,0,1,.772.624,1.191,1.191,0,0,1,.037.987,3.3,3.3,0,0,0,1.409,4.11,3.342,3.342,0,0,0,4.279-.834,1.2,1.2,0,0,1,.878-.46,1.176,1.176,0,0,1,.927.354,17.48,17.48,0,0,1,4.57,7.871,1.2,1.2,0,0,1-1,1.5,3.3,3.3,0,0,0,.01,6.537,1.2,1.2,0,0,1,.842.525,1.192,1.192,0,0,1,.156.976,17.994,17.994,0,0,1-4.581,7.873,1.227,1.227,0,0,1-.927.353,1.2,1.2,0,0,1-.878-.461,3.341,3.341,0,0,0-4.279-.835,3.3,3.3,0,0,0-1.412,4.1,1.194,1.194,0,0,1-.809,1.609A18.264,18.264,0,0,1,29.274,46.32Zm-2.762-2.635a15.742,15.742,0,0,0,5.576-.009,5.708,5.708,0,0,1,2.8-5.727,5.771,5.771,0,0,1,6.389.45,15.63,15.63,0,0,0,2.8-4.8,5.676,5.676,0,0,1-.008-10.557,14.773,14.773,0,0,0-2.788-4.8,5.778,5.778,0,0,1-6.389.449,5.706,5.706,0,0,1-2.8-5.735,15.809,15.809,0,0,0-5.576.008,5.708,5.708,0,0,1-2.8,5.728,5.771,5.771,0,0,1-6.389-.449,15.6,15.6,0,0,0-2.8,4.8A5.676,5.676,0,0,1,14.535,33.6a14.763,14.763,0,0,0,2.788,4.8,5.774,5.774,0,0,1,6.389-.45A5.706,5.706,0,0,1,26.513,43.685Z"
              transform="translate(0.917 0)"
              fill={color}
            />
            <path
              id="Path_6603"
              data-name="Path 6603"
              d="M388.837,388.775a1.208,1.208,0,0,1-.851-.352l-3.744-3.724a1.2,1.2,0,0,1,1.688-1.7l2.908,2.892,7.017-6.977a1.2,1.2,0,0,1,1.71.048,1.193,1.193,0,0,1,0,1.63l-7.877,7.834A1.194,1.194,0,0,1,388.837,388.775Z"
              transform="translate(-360.68 -355.357)"
              fill={color}
            />
          </g>
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.Signout && (
        <svg
          id="Controls_Icon_Logout"
          data-name="Controls/Icon/Logout"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
        >
          <path
            id="Path_26146"
            data-name="Path 26146"
            d="M0,0H38V38H0Z"
            fill="none"
          />
          <path
            id="Path_26147"
            data-name="Path 26147"
            d="M27.5,10.111l-2.4,2.507,4.386,4.6H12.2v3.556H29.489L25.1,25.364l2.4,2.524L36,19ZM5.4,6.556H19V3H5.4A3.491,3.491,0,0,0,2,6.556V31.444A3.491,3.491,0,0,0,5.4,35H19V31.444H5.4Z"
            fill={color}
          />
        </svg>
      )}
      {(icon as MenuIcons) === MenuIcons.TimeEntry && (
        <svg
          id="Controls_icon_Time_Entry"
          data-name="Controls/icon/Time_Entry"
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 38 38"
        >
          <rect
            id="Rectangle_2263"
            data-name="Rectangle 2263"
            width="38"
            height="38"
            fill="none"
            opacity="0"
          />
          <g
            id="Group_8906"
            data-name="Group 8906"
            transform="translate(194.385 -421.539)"
          >
            <path
              id="Path_6624"
              data-name="Path 6624"
              d="M-171.484,434.856a.557.557,0,0,0-.555-.56h-5.845l-3.636-3.678a.552.552,0,0,0-.785,0,.564.564,0,0,0,0,.792l3.8,3.841c0,.005.01.005.014.01a.542.542,0,0,0,.167.112.562.562,0,0,0,.213.044h6.075A.557.557,0,0,0-171.484,434.856Z"
              transform="translate(-0.901 -0.84)"
              fill={color}
            />
            <path
              id="Path_6625"
              data-name="Path 6625"
              d="M-162.308,435.072h-5.4c.032-.351.053-.706.053-1.066a11.43,11.43,0,0,0-11.367-11.466,11.417,11.417,0,0,0-11.367,11.466,11.417,11.417,0,0,0,11.367,11.466c.385,0,.765-.021,1.141-.058V456.6a1.935,1.935,0,0,0,1.922,1.94h13.648a1.936,1.936,0,0,0,1.922-1.94V437.009A1.937,1.937,0,0,0-162.308,435.072Zm-16.153,8.5v-.9a.557.557,0,0,0-.555-.56.557.557,0,0,0-.555.56v.9a9.42,9.42,0,0,1-5.76-2.409l.63-.636a.565.565,0,0,0,0-.792.551.551,0,0,0-.785,0l-.63.636a9.6,9.6,0,0,1-2.389-5.811h.894a.558.558,0,0,0,.556-.56.558.558,0,0,0-.556-.56h-.9a9.59,9.59,0,0,1,2.389-5.811l.63.636a.551.551,0,0,0,.784.013.563.563,0,0,0,.014-.791l-.014-.013-.63-.636a9.418,9.418,0,0,1,5.761-2.41v.9a.557.557,0,0,0,.555.56.557.557,0,0,0,.555-.56v-.9a9.43,9.43,0,0,1,5.761,2.41l-.631.636a.563.563,0,0,0-.012.791.551.551,0,0,0,.784.013l.013-.013.63-.636a9.59,9.59,0,0,1,2.389,5.811h-.894a.557.557,0,0,0-.555.56.557.557,0,0,0,.555.56h.892c-.009.171-.031.339-.05.507h-2.067a3.8,3.8,0,0,0-2.247.864l-2.975,2.664a3.36,3.36,0,0,0-1.009,2.278v2.64C-178.071,443.541-178.265,443.565-178.461,443.577Zm6.546-3.2,0,0,0,0Zm-2.939-.828,2.091-1.874v1.874Zm-.984,16.937V441.6h4.1a1.024,1.024,0,0,0,1.018-1.027v-3.447h8.3l0,19.356Z"
              transform="translate(0)"
              fill={color}
            />
            <path
              id="Path_6626"
              data-name="Path 6626"
              d="M-163.427,446.99h-7.128a1.025,1.025,0,0,0-1.019,1.028,1.025,1.025,0,0,0,1.019,1.028h7.128a1.025,1.025,0,0,0,1.019-1.028A1.025,1.025,0,0,0-163.427,446.99Z"
              transform="translate(-2.14 -2.595)"
              fill={color}
            />
            <path
              id="Path_6627"
              data-name="Path 6627"
              d="M-163.427,450.861h-7.128a1.025,1.025,0,0,0-1.019,1.028,1.025,1.025,0,0,0,1.019,1.027h7.128a1.025,1.025,0,0,0,1.019-1.027A1.025,1.025,0,0,0-163.427,450.861Z"
              transform="translate(-2.14 -3.006)"
              fill={color}
            />
            <path
              id="Path_6628"
              data-name="Path 6628"
              d="M-163.427,454.731h-7.128a1.025,1.025,0,0,0-1.019,1.028,1.025,1.025,0,0,0,1.019,1.027h7.128a1.025,1.025,0,0,0,1.019-1.027A1.025,1.025,0,0,0-163.427,454.731Z"
              transform="translate(-2.14 -3.416)"
              fill={color}
            />
          </g>
        </svg>
      )}
    </>
  );
}
